export default "__VITE_ASSET__4VwKGdgR__"